import React from 'react';
import { Table } from '@fikasio/react-ui-components';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EmptyTableRow from 'components/UI/EmptyTableRow';
import UserAvatar from 'components/UI/UserAvatar';
import { ListedUser } from 'services/users/types';

const UsersList = ({
  onUserClick,
  selectedUserId,
  users,
}: {
  onUserClick?: (userId: string) => void;
  selectedUserId?: string;
  users?: ListedUser[];
}) => {
  const { t } = useTranslation();

  return (
    <Table
      bordered
      hover
      responsive
    >
      <thead>
        <tr>
          <th style={{ width: 50 }} />
          <th>{t('name')}</th>
          <th>{t('emailAddress')}</th>
        </tr>
      </thead>
      <tbody>
        {
          (!users || !users.length) && (
            <EmptyTableRow
              colSpan={3}
              message={t('noUsersToDisplay')}
            />
          )
        }
        {
          [...(users || [])]
            .sort((u1, u2) => u1.name.toLowerCase().localeCompare(u2.name.toLowerCase()))
            .map(user => (
              <tr
                className={classNames({
                  selected: user.id === selectedUserId,
                })}
                key={user.id}
                onClick={() => onUserClick?.(user.id)}
                style={{
                  cursor: onUserClick ? 'pointer' : undefined,
                }}
              >
                <td
                  style={{
                    textAlign: 'center',
                    width: 50,
                  }}
                >
                  <UserAvatar
                    hasProfilePicture={user.hasProfilePicture}
                    modifiedAt={user.modifiedAt}
                    size={28}
                    userId={user.id}
                  />
                </td>
                <td>{user.name}</td>
                <td>{user.emailAddress}</td>
              </tr>
            ))
        }
      </tbody>
    </Table>
  );
};

export default UsersList;
